import type { FC, ReactNode } from "react";

interface BaseTooltipContentProps {
  label: ReactNode;
  entries: readonly {
    color?: string;
    label?: ReactNode;
    value: ReactNode;
  }[];
}

export const BaseTooltipContent: FC<BaseTooltipContentProps> = (props) => {
  return (
    <div className="rounded-sm border border-border-light bg-white px-3 py-2 text-sm shadow-xs">
      <div className="mb-1 font-medium text-foreground">{props.label}</div>
      {props.entries.map((entry, index) => (
        <div key={index} className="flex items-center gap-2">
          <span
            className="inline-block h-2.5 w-2.5 rounded-xs"
            style={{ backgroundColor: entry.color ?? "var(--color-gray-400)" }}
          />
          {entry.label ? (
            <span className="max-w-32 truncate text-gray-600">
              {entry.label}
            </span>
          ) : null}
          <span className="ml-auto font-medium">{entry.value}</span>
        </div>
      ))}
    </div>
  );
};
